import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgLink = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.631 6.79H8.21A5.22 5.22 0 0 0 3 12c0 2.86 2.34 5.208 5.21 5.208h1.421M14.369 6.79h1.421A5.22 5.22 0 0 1 21 12c0 2.86-2.34 5.208-5.21 5.208h-1.421"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLink);
export default ForwardRef;
